export default {
    "Add email addresses": "Ajouter des adresses email",
    "Enter one or more email addresses": "Saisir une ou plusieurs adresses email",
    "one addresse will be added | {count} addresses will be added": "une adresse sera ajoutée | {count} adresses seront ajoutées",
    "Add": "Ajouter",
    "Remove?": "Supprimer ?",
    "Are you sure you want to remove ": "Êtes-vous sûr de vouloir supprimer ",
    " item(s)?": " élément(s) ?",
    "Remove": "Supprimer",
    "Remove all?": "Tout supprimer ?",
    "Are you sure you want to remove all tracking items? This action cannot be undone.": "Êtes-vous sûr de vouloir supprimer tous les éléments de suivi ? Cette action ne peut pas être annulée.",
    "Remove all": "Tout supprimer",
    "Select the item | Select all {count} items": "Sélectionner l'élément | Sélectionner les {count} éléments",
    "Clear selection": "Annuler la sélection",
    "Cancel": "Annuler",
    "Edit address": "Modifier l'adresse",
    "Edit": "Modifier",
    "Email address": "Adresse email",
    "Domain": "Domaine",
    "Search...": "Rechercher...",
    "Email address or domain": "Adresse email ou domaine",
    "The list is empty": "La liste est vide",
    "every address": "toutes les adresses",
    "Load more": "Charger plus",
    "Settings": "Paramètres",
    "Export list": "Exporter la liste",
    "one already in the list | {count} already in the list": "une déjà présente | {count} déjà présentes",
    "one invalid | {count} invalid": "une invalide | {count} invalides",
    "Guests enter their email address, then the code they receive by email.": "Les invités saisissent leur adresse email, puis le code reçu par email.",
    "An allowed email address or domain is enough to access the page.": "Une adresse email ou un domaine autorisé suffit pour accéder à la page.",
    "Verification code by email": "Code de vérification par email",
    "Required": "Requis",
    "Disabled": "Désactivé",
    "Verification code disabled": "Code de vérification désactivé",
    "one selected | {count} selected": "un sélectionné | {count} sélectionnés",
    "Add email addresses or whole domains to allow guests.": "Ajoutez des adresses email ou des domaines entiers pour autoriser des invités.",
    
    // Nouvelles traductions pour WhitelistListingAddDomain
    "Add domain": "Ajouter un domaine",
    "Every email addresses of the domain will be whitelisted": "Toutes les adresses email de ce domaine seront autorisées",
    "OK": "OK",
    
    // Nouvelles traductions pour WhitelistTracking
    "Export": "Exporter",
    "Export complete log": "Exporter le journal complet",
    "Last connection": "Dernière connexion",
    "Total time spent": "Temps total passé",
    "hour(s)": "heure(s)",
    "minute(s)": "minute(s)",
    "second(s)": "seconde(s)",
    "Online": "En ligne",
    "Online only": "En ligne uniquement",
    "You are not allowed to access this event": "Vous n'êtes pas autorisé à rejoindre cet évènement",

    // WhitelistSas
    "Join the event": "Rejoindre l'événement",
    "Email": "Email",
    "Code": "Code",
    "Change": "Modifier",
    "A code will be sent to your email address": "Un code vous sera envoyé par email",
    "Enter your email address to access the event": "Saisissez votre adresse email pour accéder à l'événement",
    "Send code": "Envoyer le code",
    "Enter your code": "Entrer votre code",
    "Enter the code you received by email": "Entrez le code que vous avez reçu par email",
    "I didn't receive a code": "Je n'ai pas reçu de code",
    "Access the broadcast": "Accéder à la diffusion",
    "A new code has been sent. Remember to check your spam folder.": "Un nouveau code a été envoyé. Pensez à vérifier vos spams.",
    "Please enter your email address": "Veuillez saisir votre adresse email",
    "This email address is not authorized to access this event": "Cette adresse email n'est pas autorisée à rejoindre cet événement",
    "Please enter the code": "Veuillez saisir le code",
    "The code you entered is invalid or has already been used": "Le code saisi est invalide ou a déjà été utilisé",
    "Please wait a few seconds before requesting a new code": "Veuillez patienter quelques secondes avant de demander un nouveau code",
    "An error occurred while sending the code. Please try again.": "Une erreur est survenue lors de l'envoi du code. Veuillez réessayer.",

    "sso_error:access_denied":   "Authentification annulée. Veuillez réessayer et accepter les permissions demandées.",
    "sso_error:unallowed_email": "Votre adresse email n'est pas autorisée à accéder à cet événement.",
    "sso_error:unknown":         "Erreur d'authentification. Veuillez réessayer.",
}